import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('QiaoBill-index-1992f2b83bd5d718c-1'),
    routerUrl: '/QiaoBill',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./QiaoBill')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('QiaoBill-index-1992f2b83bd5d718c-2'),
        routerUrl: '/QiaoBillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./QiaoBillForm')),
      },
      //$MORE$
    ],
  },
];
